import React from 'react';
import ContentPanel from "../components/ContentPanel/ContentPanel";
import Skeleton from "../components/Skeleton/Skeleton";
import ContentAccordion from "../components/ContentAccordion/ContentAccordion";
import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs';
import store from "../store";
import {Helmet} from "react-helmet";

const privacyPolicy = () => {

  return (
      <div className="wrapper mb36">
          <Helmet>
              {
                  store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                      return row.rowTitle === "Legal" ? row.sections.map((section) => {
                          return section.title === "Privacy Policy" ? <meta name="description" content={section.content['seo-description']}/> : null
                      }) : null
                  }) : null
              }
          </Helmet>
        <Breadcrumbs pageTitle="Privacy Policy"/>
          <ContentPanel
              skeleton={<Skeleton type="MAIN_PANEL"/>}
              errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
              templateUrl="./content/home/page-components/text-block/privacy-policy-heading.html"
          />

          <ContentAccordion jsonDataUrl="./content/home/page-components/accordion/privacy-policy.json"/>
      </div>
  )

};

export default privacyPolicy;



// WEBPACK FOOTER //
// ./src/pages/PrivacyPolicy.js